import './RatesList.sass';

import * as React from 'react';
import { connect } from 'react-redux';

import {
  getGeneralRolesPermissions,
  getRolesPermissions,
  getUser,
} from '../../components/Login/selectors';
import NumberUtils from '../../lib/NumberUtils';
import {
  hasPagePermissionRates,
  hasPermissions,
} from '../../utilities/FilterLinksForTabs';
import RateLine from './RateLine';

class RatesList extends React.Component {
  render() {
    const {
      title,
      rates,
      selected,
      onRateClick,
      onPlusClick,
      rolesPermissions,
      user,
      generalRolesPermissions,
    } = this.props;

    const pmk = rates.find((rate) => rate.isPmkOnly);

    return (
      <div className="rates-list-component">
        {(title || onPlusClick) && (
          <div className="rates-title">
            {title}
            {onPlusClick && (
              <i className="fa fa-plus fa-lg mt-1" onClick={onPlusClick} />
            )}
            <div className="line-quals-page" />
          </div>
        )}
        <div className="rates-list">
          {pmk && (
            <div>
              <RateLine
                onClick={() => onRateClick(pmk)}
                name={`${pmk.name}`}
                selected={selected && pmk.id === selected.id}
                pmk
              />
              <hr />
            </div>
          )}
          {rates.length ? (
            rates
              .filter((rate) => !rate.isPmkOnly)
              .map((rate) => (
                <div className="row" key={NumberUtils.obtainUniqueKey()}>
                  <RateLine
                    onClick={() => onRateClick(rate)}
                    name={`${rate.name} ${
                      rate.shortname ? `(${rate.shortname})` : ''
                    }`}
                    selected={selected && rate.id === selected.id}
                    withBibShortcut={
                      hasPermissions('Bibliography', rolesPermissions, rate) ||
                      hasPagePermissionRates(
                        'Bibliography',
                        generalRolesPermissions,
                      ) ||
                      user.isSuperAdmin
                    }
                    withSubtopicShortcut={
                      hasPermissions('Subtopics', rolesPermissions, rate) ||
                      hasPagePermissionRates(
                        'Subtopics',
                        generalRolesPermissions,
                      ) ||
                      user.isSuperAdmin
                    }
                    pmk={false}
                    id={rate.id}
                  />
                </div>
              ))
          ) : (
            <p>No Rates</p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  rolesPermissions: getRolesPermissions(state),
  generalRolesPermissions: getGeneralRolesPermissions(state),
  user: getUser(state),
});

export default connect(mapStateToProps)(RatesList);
